<template>
    <div id="print-card">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-6 justify-content-center">

                    <div v-if="spinnerLoading" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <div class="card">
                        <img class="img-fluid" :src="cardClient.frente" alt="">
                        <button v-on:click="printImage(cardClient.frente)" class="formSubmit">
                            IMPRIMIR FRENTE
                        </button>
                    </div>

                </div>
                <div class="col-12 col-sm-6 justify-content-center">

                    <div v-if="spinnerLoading" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <div class="card">
                        <img class="img-fluid" :src="cardClient.vuelta" alt="">
                        <button v-on:click="printImage(cardClient.vuelta)" class="formSubmit">
                            IMPRIMIR REVERSO
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {clientsService} from "../../Services/Clients.service";

export default {
    name: 'print-card',
    mixins: [myMixins],
    props: {
        sku: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            spinnerLoading: false,
            showCard: false,
            cardClient: [],
        }
    },
    methods: {
        async index() {
            this.spinnerLoading = true;
            this.cardClient = await clientsService.getCardClient(this.sku);
            if (this.cardClient.frente !== 'process') {
                this.showCard = true;
                this.spinnerLoading = false;
            } else {
                this.spinnerLoading = false;
                this.showCard = false;
                this.getAlert(this.cardClient.vuelta);
            }
            //console.log('cardClient', this.cardClient);
        },
    },
    mounted() {
        this.index();
    },
}
</script>
